module.exports = __webpack_public_path__ + "f8badc233e5356cb2ef1942cd9dfd9ef.pdf";